// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: flex-start;\n  background-color: var(--primary-color);\n  padding: 0 2rem 2rem 2rem;\n  margin-top: 8rem;\n}\n.banner__title {\n  font-size: 2rem;\n  color: #f5f5f5;\n}\n.banner__sub-title {\n  font-size: 1.6rem;\n  color: #f5f5f5;\n}\n", ""]);
// Exports
module.exports = exports;
